const deviceName = state => state.deviceName;

const deviceToken = state => state.deviceToken;

export default {
  deviceName,
  deviceToken
};



// WEBPACK FOOTER //
// ./src/store/modules/device/getters.js